import React from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

import { MenuItem } from "@/model/entities";
import MenuItemViewerCard from "@/components/MenuItemViewerCard";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

interface CategorySection2Props {
  category: { id?: string | null; name: string };
  menuItems: MenuItem[];
  isMenuItemsLoading: boolean;
  onMenuItemClick: (categoryId: string, item: MenuItem) => void;
}

const CategorySection2: React.FC<CategorySection2Props> = ({
  category,
  menuItems,
  isMenuItemsLoading,
  onMenuItemClick,
}) => {
  const { t } = useTranslation();

  return (
    <Card
      id={`category-${category.id}`}
      className="mb-2"
  style={{ backgroundImage: `linear-gradient(to bottom, #f3f0ff, white)` }}
    >
      <CardHeader className="flex justify-center">
        <CardTitle >
          {category.name}
        </CardTitle>
      </CardHeader>

      <CardContent className="px-2">
        {isMenuItemsLoading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-6 w-6 animate-spin text-primary" />
          </div>
        ) : menuItems.length > 0 ? (
          <div className="relative">
            {/* Horizontal scroll container: always single row. Use a fixed height so all cards match. */}
            <div className="flex gap-4 overflow-x-auto pb-2 hide-scrollbar touch-auto items-stretch h-72">
              {menuItems.map((item: MenuItem) => (
                <div key={item.id} className="flex-shrink-0 w-44 sm:w-52 md:w-60 h-full">
                  <MenuItemViewerCard
                    item={item}
                    onClick={() => category.id && onMenuItemClick(category.id, item)}
                    className="h-full flex flex-col"
                  />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <Card className="border border-dashed">
            <CardContent className="py-6 text-center text-gray-500">
              {t("category.noItemsInThisCategory", "אין פריטים בקטגוריה זו")}
            </CardContent>
          </Card>
        )}
      </CardContent>
    </Card>
  );
};

export default CategorySection2;
